// extracted by mini-css-extract-plugin
export var active = "_1t-d";
export var blink = "_1t-e";
export var container = "_1t-5";
export var controls = "_1t-0";
export var controlsRight = "_1t-1";
export var fakeCursor = "_1t-c";
export var hidden = "_1t-b";
export var quillContainerSmall = "_1t-7";
export var quillEditor = "_1t-6";
export var quillEditorSmall = "_1t-8";
export var quillFormatButtons = "_1t-a";
export var quillToolbar = "_1t-9";
export var removePadding = "_1t-2";
export var state = "_1t-3";
export var stateTitle = "_1t-4";